import React from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import { useOneButtonStore } from '../../../../../store/oneButtonStore';

export type OBDSelectProps<ValueType = any, OptionType extends object = any> = SelectProps<ValueType, OptionType>;

const OBDSelect = <ValueType, OptionType extends object = any>({
    className,
    popupClassName,
    classNames,
    ...props
}: OBDSelectProps<ValueType, OptionType>) => {
    const theme = useOneButtonStore((s) => s.theme);
    const mergedClassName = className ? `obd-utility__select ${className}` : 'obd-utility__select';
    const existingPopupRoot =
        classNames && typeof classNames.popup === 'object' ? classNames.popup.root : undefined;
    const mergedPopupRoot = [popupClassName, existingPopupRoot, `obd-select-dropdown obd-theme-${theme}`]
        .filter(Boolean)
        .join(' ');

    return (
        <Select<ValueType, OptionType>
            {...props}
            className={mergedClassName}
            classNames={{
                ...classNames,
                popup: {
                    ...(typeof classNames?.popup === 'object' ? classNames.popup : {}),
                    root: mergedPopupRoot,
                },
            }}
        />
    );
};

export default OBDSelect;
